import { useState, useEffect } from 'react';
import api from '../api';
import toast from 'react-hot-toast';

// Šalių šventės
const COUNTRY_HOLIDAYS = {
  LT: {
    name: '🇱🇹 Lietuva',
    holidays: (y) => [
      { date: `${y}-01-01`, name: 'Naujieji metai' },
      { date: `${y}-02-16`, name: 'Valstybės atkūrimo diena' },
      { date: `${y}-03-11`, name: 'Nepriklausomybės atkūrimo diena' },
      { date: `${y}-05-01`, name: 'Tarptautinė darbo diena' },
      { date: `${y}-06-24`, name: 'Rasos ir Joninių diena' },
      { date: `${y}-07-06`, name: 'Valstybės diena' },
      { date: `${y}-08-15`, name: 'Žolinė (Švč. M. Marijos ėmimo į dangų diena)' },
      { date: `${y}-11-01`, name: 'Visų šventųjų diena' },
      { date: `${y}-11-02`, name: 'Vėlinės' },
      { date: `${y}-12-24`, name: 'Kūčios' },
      { date: `${y}-12-25`, name: 'Kalėdos' },
      { date: `${y}-12-26`, name: 'Kalėdų antroji diena' },
    ]
  },
  LV: {
    name: '🇱🇻 Latvija',
    holidays: (y) => [
      { date: `${y}-01-01`, name: 'Jaunais gads' },
      { date: `${y}-05-01`, name: 'Darba svētki' },
      { date: `${y}-05-04`, name: 'Latvijas Republikas neatkarības atjaunošanas diena' },
      { date: `${y}-06-23`, name: 'Līgo diena' },
      { date: `${y}-06-24`, name: 'Jāņu diena' },
      { date: `${y}-11-18`, name: 'Latvijas Republikas proklamēšanas diena' },
      { date: `${y}-12-24`, name: 'Ziemassvētku vakars' },
      { date: `${y}-12-25`, name: 'Ziemassvētki' },
      { date: `${y}-12-26`, name: 'Otrie Ziemassvētki' },
      { date: `${y}-12-31`, name: 'Vecgada vakars' },
    ]
  },
  EE: {
    name: '🇪🇪 Estija',
    holidays: (y) => [
      { date: `${y}-01-01`, name: 'Uusaasta' },
      { date: `${y}-02-24`, name: 'Eesti Vabariigi aastapäev' },
      { date: `${y}-05-01`, name: 'Kevadpüha' },
      { date: `${y}-06-23`, name: 'Võidupüha' },
      { date: `${y}-06-24`, name: 'Jaanipäev' },
      { date: `${y}-08-20`, name: 'Taasiseseisvumispäev' },
      { date: `${y}-12-24`, name: 'Jõululaupäev' },
      { date: `${y}-12-25`, name: 'Esimene jõulupüha' },
      { date: `${y}-12-26`, name: 'Teine jõulupüha' },
    ]
  },
  PL: {
    name: '🇵🇱 Lenkija',
    holidays: (y) => [
      { date: `${y}-01-01`, name: 'Nowy Rok' },
      { date: `${y}-01-06`, name: 'Święto Trzech Króli' },
      { date: `${y}-05-01`, name: 'Święto Pracy' },
      { date: `${y}-05-03`, name: 'Święto Konstytucji 3 Maja' },
      { date: `${y}-08-15`, name: 'Wniebowzięcie NMP' },
      { date: `${y}-11-01`, name: 'Wszystkich Świętych' },
      { date: `${y}-11-11`, name: 'Święto Niepodległości' },
      { date: `${y}-12-25`, name: 'Boże Narodzenie' },
      { date: `${y}-12-26`, name: 'Drugi dzień Bożego Narodzenia' },
    ]
  },
  DE: {
    name: '🇩🇪 Vokietija',
    holidays: (y) => [
      { date: `${y}-01-01`, name: 'Neujahrstag' },
      { date: `${y}-05-01`, name: 'Tag der Arbeit' },
      { date: `${y}-10-03`, name: 'Tag der Deutschen Einheit' },
      { date: `${y}-12-25`, name: '1. Weihnachtstag' },
      { date: `${y}-12-26`, name: '2. Weihnachtstag' },
    ]
  },
  GB: {
    name: '🇬🇧 Jungtinė Karalystė',
    holidays: (y) => [
      { date: `${y}-01-01`, name: "New Year's Day" },
      { date: `${y}-05-06`, name: 'Early May Bank Holiday' },
      { date: `${y}-05-27`, name: 'Spring Bank Holiday' },
      { date: `${y}-08-26`, name: 'Summer Bank Holiday' },
      { date: `${y}-12-25`, name: 'Christmas Day' },
      { date: `${y}-12-26`, name: 'Boxing Day' },
    ]
  },
};

// Suskaičiuoti savaitgalius per metus
function getWeekends(year) {
  const weekends = [];
  const date = new Date(year, 0, 1);
  while (date.getFullYear() === year) {
    const day = date.getDay();
    if (day === 0 || day === 6) {
      const iso = date.toISOString().slice(0, 10);
      weekends.push({
        date: iso,
        name: day === 6 ? 'Šeštadienis' : 'Sekmadienis',
        is_weekend: true,
      });
    }
    date.setDate(date.getDate() + 1);
  }
  return weekends;
}

const monthNames = ['Sausis','Vasaris','Kovas','Balandis','Gegužė','Birželis','Liepa','Rugpjūtis','Rugsėjis','Spalis','Lapkritis','Gruodis'];

export default function Holidays() {
  const [holidays,    setHolidays]    = useState([]);
  const [year,        setYear]        = useState(new Date().getFullYear());
  const [form,        setForm]        = useState({ date: '', name: '' });
  const [loading,     setLoading]     = useState(false);
  const [importing,   setImporting]   = useState(false);
  const [showImport,  setShowImport]  = useState(false);
  const [selCountry,  setSelCountry]  = useState('LT');
  const [incWeekends, setIncWeekends] = useState(true);

  useEffect(() => { loadData(); }, [year]);

  async function loadData() {
    const r = await api.get(`/holidays?year=${year}`);
    setHolidays(r.data);
  }

  async function handleAdd(e) {
    e.preventDefault(); setLoading(true);
    try {
      await api.post('/holidays', { ...form, is_public: false });
      toast.success('Pridėta');
      setForm({ date: '', name: '' });
      loadData();
    } catch(err) { toast.error(err.response?.data?.error || 'Klaida'); }
    finally { setLoading(false); }
  }

  async function handleDelete(id) {
    await api.delete(`/holidays/${id}`);
    loadData();
  }

  async function handleImport() {
    setImporting(true);
    let added = 0;
    try {
      const countryHols = COUNTRY_HOLIDAYS[selCountry]?.holidays(year) || [];
      const weekends    = incWeekends ? getWeekends(year) : [];
      const all         = [...countryHols, ...weekends];

      for (const h of all) {
        try {
          await api.post('/holidays', { date: h.date, name: h.name, is_public: true });
          added++;
        } catch(e) { /* jau egzistuoja */ }
      }
      toast.success(`✅ Įkelta ${added} dienų`);
      setShowImport(false);
      loadData();
    } catch(e) { toast.error('Klaida importuojant'); }
    finally { setImporting(false); }
  }

  async function handleDeleteAll() {
    if (!window.confirm(`Ištrinti visas ${year} m. nedarbo dienas?`)) return;
    for (const h of holidays) {
      await api.delete(`/holidays/${h.id}`);
    }
    toast.success('Ištrinta'); loadData();
  }

  // Grupuoti pagal mėnesį
  const byMonth = {};
  for (const h of holidays) {
    const m = parseInt(h.date.slice(5,7)) - 1;
    if (!byMonth[m]) byMonth[m] = [];
    byMonth[m].push(h);
  }

  const countryHolCount = COUNTRY_HOLIDAYS[selCountry]?.holidays(year).length || 0;
  const weekendCount    = getWeekends(year).length;

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:12 }}>
        <div>
          <div className="page-title">Šventės ir nedarbo dienos</div>
          <div className="page-subtitle">{holidays.length} dienų pažymėta {year} m.</div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
          <select className="form-input" style={{ width:100 }} value={year} onChange={e => setYear(parseInt(e.target.value))}>
            {[2024,2025,2026,2027,2028].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-secondary" onClick={() => setShowImport(v => !v)}>
            📥 Importuoti automatiškai
          </button>
          {holidays.length > 0 && (
            <button className="btn btn-danger" onClick={handleDeleteAll}>🗑️ Išvalyti {year} m.</button>
          )}
        </div>
      </div>

      {/* Import panel */}
      {showImport && (
        <div className="card" style={{ marginBottom:20, border:'1px solid rgba(59,130,246,0.3)', background:'rgba(59,130,246,0.05)' }}>
          <div style={{ fontWeight:700, fontSize:14, marginBottom:16 }}>📥 Automatinis importas</div>
          <div style={{ display:'flex', gap:16, flexWrap:'wrap', alignItems:'flex-end' }}>
            <div className="form-group" style={{ marginBottom:0 }}>
              <label className="form-label">Šalis</label>
              <select className="form-input" value={selCountry} onChange={e => setSelCountry(e.target.value)} style={{ width:220 }}>
                {Object.entries(COUNTRY_HOLIDAYS).map(([k,v]) => (
                  <option key={k} value={k}>{v.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', padding:'10px 14px', background:'var(--bg)', borderRadius:8, border:'1px solid var(--border)', height:40 }}>
                <input type="checkbox" checked={incWeekends} onChange={e => setIncWeekends(e.target.checked)} style={{ width:16,height:16 }} />
                <span style={{ fontSize:13 }}>Įtraukti savaitgalius</span>
              </label>
            </div>
            <button className="btn btn-primary" onClick={handleImport} disabled={importing} style={{ height:40 }}>
              {importing ? <span className="loading-spinner" /> : `📥 Įkelti (${countryHolCount} švenčių${incWeekends ? ` + ${weekendCount} savaitgalių` : ''})`}
            </button>
          </div>
          <div style={{ fontSize:11, color:'var(--text-muted)', marginTop:10 }}>
            ℹ️ Jau esančios dienos nebus dubliuojamos. Galite importuoti kelis kartus.
          </div>
        </div>
      )}

      {/* Pridėjimo forma */}
      <div className="card" style={{ marginBottom:20 }}>
        <div style={{ fontSize:13, fontWeight:700, marginBottom:12 }}>➕ Pridėti konkrečią dieną rankiniu būdu</div>
        <form onSubmit={handleAdd}>
          <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end' }}>
            <div className="form-group" style={{ marginBottom:0, width:180 }}>
              <label className="form-label">Data</label>
              <input className="form-input" type="date" value={form.date} onChange={e => setForm({...form,date:e.target.value})} required />
            </div>
            <div className="form-group" style={{ marginBottom:0, flex:1, minWidth:200 }}>
              <label className="form-label">Pavadinimas</label>
              <input className="form-input" value={form.name} onChange={e => setForm({...form,name:e.target.value})} required placeholder="pvz. Įmonės šventė, Kapitalinis remontas..." />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ height:40 }}>
              {loading ? <span className="loading-spinner"/> : '➕ Pridėti'}
            </button>
          </div>
        </form>
      </div>

      {/* Statistika */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Iš viso dienų', value: holidays.length, color:'var(--accent)' },
          { label:'Valstybinės šventės', value: holidays.filter(h=>h.is_public && !['Šeštadienis','Sekmadienis'].includes(h.name)).length, color:'#f59e0b' },
          { label:'Savaitgaliai', value: holidays.filter(h=>['Šeštadienis','Sekmadienis'].includes(h.name)).length, color:'#8b5cf6' },
          { label:'Kitos dienos', value: holidays.filter(h=>!h.is_public).length, color:'#10b981' },
        ].map(s => (
          <div key={s.label} className="card" style={{ textAlign:'center', padding:'12px' }}>
            <div style={{ fontSize:22, fontWeight:800, color:s.color }}>{s.value}</div>
            <div style={{ fontSize:11, color:'var(--text-muted)' }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Kalendoriaus vaizdas */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:14 }}>
        {Array.from({length:12},(_,i)=>i).map(m => {
          const mHols = byMonth[m] || [];
          const pubHols = mHols.filter(h => h.is_public && !['Šeštadienis','Sekmadienis'].includes(h.name));
          const weekends = mHols.filter(h => ['Šeštadienis','Sekmadienis'].includes(h.name));
          const custom   = mHols.filter(h => !h.is_public);
          return (
            <div key={m} className="card" style={{ padding:'14px' }}>
              <div style={{ fontWeight:700, fontSize:13, marginBottom:10, color:'var(--accent)', display:'flex', justifyContent:'space-between' }}>
                <span>{monthNames[m]} {year}</span>
                {mHols.length > 0 && <span style={{ fontSize:11, color:'var(--text-muted)' }}>{mHols.length} d.</span>}
              </div>
              {mHols.length === 0
                ? <div style={{ fontSize:12, color:'var(--text-muted)' }}>Švenčių nėra</div>
                : <>
                    {pubHols.map(h => (
                      <div key={h.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'4px 0', borderBottom:'1px solid var(--border)' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                          <span style={{ fontSize:11, fontWeight:700, color:'#f59e0b', width:20 }}>{h.date.slice(8)}</span>
                          <span style={{ fontSize:12 }}>{h.name}</span>
                        </div>
                        <button onClick={() => handleDelete(h.id)} style={{ background:'none',border:'none',cursor:'pointer',color:'#ef4444',fontSize:12,opacity:0.6,padding:'0 4px' }}>✕</button>
                      </div>
                    ))}
                    {weekends.length > 0 && (
                      <div style={{ marginTop:4, padding:'4px 6px', background:'rgba(139,92,246,0.08)', borderRadius:6, fontSize:11, color:'#8b5cf6' }}>
                        🗓️ {weekends.length} savaitgal{weekends.length === 1 ? 'is' : 'iai'}
                        <button onClick={() => weekends.forEach(h => handleDelete(h.id))} style={{ background:'none',border:'none',cursor:'pointer',color:'#ef4444',fontSize:11,marginLeft:8 }}>✕</button>
                      </div>
                    )}
                    {custom.map(h => (
                      <div key={h.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'4px 0', borderBottom:'1px solid var(--border)' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                          <span style={{ fontSize:11, fontWeight:700, color:'#10b981', width:20 }}>{h.date.slice(8)}</span>
                          <span style={{ fontSize:12 }}>{h.name}</span>
                        </div>
                        <button onClick={() => handleDelete(h.id)} style={{ background:'none',border:'none',cursor:'pointer',color:'#ef4444',fontSize:12,opacity:0.6,padding:'0 4px' }}>✕</button>
                      </div>
                    ))}
                  </>
              }
            </div>
          );
        })}
      </div>
    </div>
  );
}